import { render, staticRenderFns } from "./EmpresaPivotTable.vue?vue&type=template&id=6df45074"
import script from "./EmpresaPivotTable.vue?vue&type=script&lang=js"
export * from "./EmpresaPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports